import { useConfigSync } from '@/config/useConfig'

export const ForgotView = (to: any, from: any) => {
  const config = useConfigSync()
  const forgotPasswordParam = config.login_ui_methods.forgot_password
  if (forgotPasswordParam === false || forgotPasswordParam === 'false') {
    return { name: 'LoginView' }
  }
}
